import React, { useEffect, useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { useIsMobileViewport } from '../../util/uiHelpers';
import { ResponsiveImage, Modal } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import ListingImageGridMobile from './ListingImageGridMobile/ListingImageGridMobile';
import ActionBarMaybe from './ActionBarMaybe';

import css from './ListingPage.module.css';

const SectionHero = props => {
  const [mounted, setMounted] = useState(false);
  // Index of the photo the full-screen carousel should open on.
  const [carouselStartIndex, setCarouselStartIndex] = useState(0);
  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    title,
    listing,
    isOwnListing,
    editParams,
    currentUser,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    noPayoutDetailsSetWithOwnListing,
  } = props;

  const isMobile = useIsMobileViewport();

  const hasImages = listing.images && listing.images.length > 0;
  const firstImage = hasImages ? listing.images[0] : null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];

  const viewPhotosButton = hasImages ? (
    <button className={css.viewPhotos} onClick={handleViewPhotosClick}>
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: listing.images.length }}
      />
    </button>
  ) : null;

  // On phones the first photos are shown as one block that fits on the screen.
  // On wider screens the single cropped cover photo is kept as it is.
  const showMobileGrid = isMobile && hasImages;

  return (
    <section className={css.sectionHero} data-testid="hero">
      <div
        className={css.imageWrapperForSectionHero}
        onClick={showMobileGrid ? null : handleViewPhotosClick}
      >
        {mounted && listing.id && isOwnListing ? (
          <div onClick={e => e.stopPropagation()} className={css.actionBarContainerForHeroLayout}>
            {noPayoutDetailsSetWithOwnListing ? (
              <ActionBarMaybe
                className={css.actionBarForHeroLayout}
                isOwnListing={isOwnListing}
                listing={listing}
                showNoPayoutDetailsSet={noPayoutDetailsSetWithOwnListing}
                currentUser={currentUser}
              />
            ) : null}

            <ActionBarMaybe
              className={css.actionBarForHeroLayout}
              isOwnListing={isOwnListing}
              listing={listing}
              editParams={editParams}
              currentUser={currentUser}
            />
          </div>
        ) : null}

        {showMobileGrid ? (
          <ListingImageGridMobile
            images={listing.images}
            imageVariants={variants}
            onImageClick={(index, e) => {
              setCarouselStartIndex(index);
              handleViewPhotosClick(e);
            }}
          />
        ) : (
          <ResponsiveImage
            rootClassName={css.rootForImage}
            alt={title}
            image={firstImage}
            variants={variants}
          />
        )}
        {viewPhotosButton}
      </div>
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        {/* The carousel only reads startIndex when it mounts, so the key forces
            a fresh one whenever another photo is tapped. */}
        <ImageCarousel
          key={carouselStartIndex}
          images={listing.images}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
          startIndex={carouselStartIndex}
        />
      </Modal>
    </section>
  );
};

export default SectionHero;
